export enum ChatType {
    CALENDARENTRY,
    CALL_PRIVATE,
    CALL_GROUP,
    CALL_UNKNOWN
}
